import { UrlCustomerManagmentClient, SearchSubscriberDTO, SubscriberDetailsDTO, AuthUser, Auth0UserDTO } from "@/Generated/ParticaAPI";
import { Auth0Import } from "@/Models/Auth0Import";

export interface IWebsiteUserService {
	getSubscribers(sub: SearchSubscriberDTO): Promise<AuthUser[]>;
	getSubscriber(user: AuthUser): Promise<SubscriberDetailsDTO>;
	updateSubscriber(sub: SubscriberDetailsDTO): Promise<any>;
	createSubscriber(subscriber: Auth0UserDTO): Promise<any>;
	getConnections(id: number): Promise<string[]>;
	importSubscribers(json: string, connection: string, domainId: number): Promise<any>;
}

export class WebsiteUserService implements IWebsiteUserService {

	private svc: UrlCustomerManagmentClient = new UrlCustomerManagmentClient();
	public async getConnections(id: number): Promise<string[]> {
		return await this.svc.getConnections(id);
	}
	public async createSubscriber(subscriber: Auth0UserDTO): Promise<any> {
		return await this.svc.createSubscriber(subscriber);
	}
	public async getSubscriber(subscriber: AuthUser): Promise<any> {
		return await this.svc.get(subscriber);
	}
	public async getSubscribers(sub: SearchSubscriberDTO): Promise<AuthUser[]> {
		return await this.svc.findSubscriber(sub);
	}
	public async updateSubscriber(sub: SubscriberDetailsDTO): Promise<any> {
		return await this.svc.updateSubscriber(sub);
	}
	public async importSubscribers(json: string, connection: string, domainId: number): Promise<any> {
		const users: Auth0Import[] = JSON.parse(json);
		let result: boolean = true;
		for (const user of users) {
			try {
				const a0u = { domainId, connection, email: user.email, userName: user.username, password: user.password } as Auth0UserDTO;
				await this.createSubscriber(a0u);
				const results = await this.getSubscribers({ domainId, email: user.email } as SearchSubscriberDTO);
				if (results.length > 0) {
					const update = { domainId, email: user.email, id: results[0].userId, expiry: user.expiry } as unknown as SubscriberDetailsDTO;
					await this.updateSubscriber(update);
				}
			} catch (error) {
				result = false;
				console.error(error.message);
				console.error(error.response.data);
				console.error(`Error importing : ${user.email}`);
			}
		}
		return result;
	}
}
